import * as React from "react";
import {
  GoogleMap,
  //   LoadScript,
  //   Marker,
  Polygon,
  useJsApiLoader,
} from "@react-google-maps/api";
import { mapStyles } from "@/utils/mapStyles";
import { findMaxDistance } from "@/utils/geo";

// import Styles from '../Map/Styles';
// import Debug from '../../Utils/Debug';

const containerStyle = {
  width: "100%",
  height: "300px",
};

export const OperationMap = ({
  area,
  location,
}: // center,
{
  area: any;
  location: { lat: number; lon: number };
  center?: any;
}) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.NEXT_PUBLIC_GMAP_API_KEY as string,
  });

  // const [map, setMap] = React.useState(null);

  // // console.log("map", map);

  // const onLoad = React.useCallback(function callback(map: any) {
  //   if (!map || !center) return;
  //   // This is just an example of getting and using the map instance!!! don't just blindly copy!
  //   const bounds = new window.google.maps.LatLngBounds(center);
  //   if (map) map.fitBounds(bounds);

  //   setMap(map);
  // }, []);

  // const onUnmount = React.useCallback(function callback(map: any) {
  //   if (map) setMap(null);
  // }, []);
  // Exemple d'utilisation
  // const coordinates: Coordinate[] = [
  //   { lat: 48.96004787, lng: 2.952821225 },
  //   { lat: 48.8566, lng: 2.3522 },
  //   { lat: 49.2827, lng: -123.1207 },
  // ];

  // console.log(
  //   `La plus longue distance est de : ${findMaxDistance(area) / 1000} km`
  // );
  const maxDistance: number = findMaxDistance(area);

  return (
    isLoaded && (
      <GoogleMap
        // onLoad={onLoad}
        // onUnmount={onUnmount}
        mapContainerStyle={containerStyle}
        center={{ lat: location.lat + 0.001, lng: location.lon - 0.003 }}
        // center={center}
        zoom={
          maxDistance < 300
            ? 16
            : maxDistance < 500
            ? 15
            : maxDistance < 800
            ? 14
            : 13
        }
        options={{
          zoomControl: false,
          fullscreenControl: false,
          styles: mapStyles,
          streetViewControl: false,
          mapTypeControl: false,
        }}
      >
        <Polygon
          draggable={false}
          editable={false}
          paths={area}
          options={{
            fillColor: "gray",
            fillOpacity: 0.2,
            strokeColor: "#333333",
            strokeOpacity: 1,
            strokeWeight: 2,
            clickable: true,
            draggable: false,
            editable: false,
            geodesic: false,
            zIndex: 1,
          }}
        />
      </GoogleMap>
    )
  );
};
